import { defineMessages } from 'react-intl';


const i18n = defineMessages({
  fNamePlaceholder: {
    id: 'placeholder.firstName',
    defaultMessage: 'First name',
  },
  lNamePlaceholder: {
    id: 'placeholder.lastName',
    defaultMessage: 'Last name',
  },
  emailPlaceholder: {
    id: 'placeholder.email',
    defaultMessage: 'Email',
  },
  choose: {
    id: 'choose',
    defaultMessage: 'Choose',
  },
  gender_M: {
    id: 'attrs.gender.M',
    defaultMessage: 'Male',
  },
  gender_F: {
    id: 'attrs.gender.F',
    defaultMessage: 'Female',
  },
  gender_U: {
    id: 'attrs.gender.U',
    defaultMessage: 'Unspecified',
  },
  respondent_type_INTERNAL: {
    id: 'attrs.candidateType.INTERNAL',
    defaultMessage: 'Internal Employee',
  },
  respondent_type_EXTERNAL: {
    id: 'attrs.candidateType.EXTERNAL',
    defaultMessage: 'External Respondent',
  },
  choose_job_profile: {
    id: 'choose.job',
    defaultMessage: 'Choose Job Profiles',
  },
  save: { id: 'actions.save', defaultMessage: 'Save' },
  cancel: { id: 'actions.cancel', defaultMessage: 'Cancel' },
  saveAndAdd: {
    id: 'actions.saveAndAdd',
    defaultMessage: 'Add another Respondent?',
  },
});

export default i18n;
